import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';

// third-party
import './coupon.scss';

// project-imports
import { updatePromotionTriggers } from '../../../actions/promotion';

import { QueryBuilderApp } from '../QueryBuilderApp';
import { alertError, alertSuccess } from '../../../helpers/errorHandling';
import InnerLoader from '../../../Components/Common/InnerLoader';

import CheckboxBigSquare from '../../../Components/Common/CheckboxBigSquare';
import CreateCouponOptions from './CreateCouponOptions';
import { Else, If, Then } from 'react-if';
import ErrorMessagesInLang from '../../Configuration/Fields/ErrorMessagesInLang';
import { getAllFields } from '../../../actions/promotion/fields';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// constant
const fieldGroups = ['basket', 'user', 'sys', 'item'];
export const DISCARD_SUBSEQUENTLY_OPTIONS = [
  {
    value: 'except_individual',
    label: 'All Promotions(Except ALWAYS RUN)',
  },
  {
    value: 'select_promotions',
    label: 'Only Select Promotions',
  },
  {
    value: 'all_except_few_selected',
    label: 'All Promotions Except Few Selected',
  },
];
const DISCARD_SUBSEQUENTLY_OPTIONS_OBJ_TMP = {};
DISCARD_SUBSEQUENTLY_OPTIONS.forEach((obj) => {
  DISCARD_SUBSEQUENTLY_OPTIONS_OBJ_TMP[obj.value] = obj;
});
export const DISCARD_SUBSEQUENTLY_OPTIONS_OBJ =
  DISCARD_SUBSEQUENTLY_OPTIONS_OBJ_TMP;

const PromotionCoupons = ({
  onCancel = () => {},
  getStores = () => {},
  promotionId,
  promotionDetail,
  updateHandler = () => {},
}) => {
  let navigate = useNavigate();

  const [currentTriggerType, setCurrentTriggerType] = useState(
    promotionDetail?.triggerType
  );
  const [coupons, setCoupons] = useState([]);

  const [couponQuery, setCouponQuery] = useState(null);
  const [triggerErrorMessages, setTriggerErrorMessages] = useState([]);
  const [priority, setPriority] = useState(0);
  const [discard, setDiscard] = useState('except_individual');
  const [alwaysRun, setAlwaysRun] = useState(false);
  const [discoverableFirst, setDiscoverableFirst] = useState(false);
  const [participatingPromotion, setParticipatingPromotion] = useState(false);
  const [promotionAppliedToAllItems, setpromotionAppliedToAllItems] =
    useState(false);
  const [triggeringOptions, setTriggeringOptions] = useState({});
  const [combinableWithPromotion, setcombinableWithPromotion] = useState([]);

  useEffect(() => {
    setCouponQuery(promotionDetail?.triggerRules);
    setPriority(promotionDetail?.basicSettings?.priority);
    setDiscard(promotionDetail?.basicSettings?.discard);
    setAlwaysRun(promotionDetail?.basicSettings?.alwaysRun);
    setDiscoverableFirst(promotionDetail?.basicSettings?.discoverableFirst);
    setParticipatingPromotion(
      promotionDetail?.basicSettings?.participatingPromotion
    );
    setTriggerErrorMessages(
      triggerErrorMessages.length
        ? triggerErrorMessages
        : promotionDetail?.triggerErrorMessages || []
    );
    setpromotionAppliedToAllItems(
      promotionDetail?.basicSettings?.promotionAppliedToAllItems
    );
    setcombinableWithPromotion(
      promotionDetail?.basicSettings?.combinableWithPromotion
    );
    setCurrentTriggerType(promotionDetail?.triggerType);
    setTriggeringOptions(promotionDetail?.triggeringOptions || {});
  }, [promotionDetail]);

  const saveTriggers = async () => {
    // dispatch(setIsShowRuleValidationError(true));
    if (true) {
      // const triggers = generateTriggerJsonLogic(query);
      const variables = {
        input: {
          promotionId: promotionId,
          triggerRules: couponQuery,
          triggerErrorMessages,
          triggerType: currentTriggerType,
          discard,
          priority,
          alwaysRun,
          discoverableFirst,
          participatingPromotion,
          combinableWithPromotion,
          promotionAppliedToAllItems,
          triggeringOptions,
        },
      };

      const { success, data, message } = await updatePromotionTriggers(
        variables
      );
      if (success) {
        alertSuccess(message);
        updateHandler();
      } else {
        alertError('Failed!, Please try again after some time');
      }
      // dispatch(setIsShowRuleValidationError(false));
    } else {
      console.log('Invalid query');
    }
  };
  // AK
  const [selectedOption, setSelectedOption] = useState(null);
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);

  const options = [
    {
      id: 'coupon',
      label: 'Applying a Coupon',
      info: 'This promotion will be triggered when a coupon is applied',
      icon: 'ri-edit-line',
    },
    {
      id: 'auto',
      label: 'Auto Applied',
      info: 'This promotion is auto applied when the trigger conditions are met',
      icon: 'ri-ticket-line',
    },
    {
      id: 'activity',
      label: 'Activity Based',
      info: 'This campaign is activated based on an activity or an event. Eg: User Registration, Wishlist (Not on transactions)',
      icon: 'ri-flag-2-line',
    },
    {
      id: 'event',
      label: 'User Event Based',
      info: 'This campaign is triggered based on user eg:- birthday, anniversary, etc.',
      icon: 'ri-calendar-event-line',
    },
  ];

  const handleSelect = (id) => {
    setSelectedOption(id);
    setIsOffcanvasOpen(true);
  };

  const toggleOffcanvas = () => {
    setIsOffcanvasOpen(!isOffcanvasOpen);
  };

  const dispatch = useDispatch();

  const getFields = async () => {
    try {
      const { data } = await getAllFields(
        {
          pageOffset: Math.max(0),
          pageSize: 2000,
        },
        dispatch
      );

      // setFields(convertFieldToQueryBuilderFormat(data));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (promotionDetail) {
      getFields();
    }
  }, [promotionDetail]);
  //
  return (
    <>
      {/*  */}
      <Row className="mb-4">
        <Col xs={12}>
          <h6 class="mb-0 fw-semibold text-uppercase">Trigger Type</h6>
          <div className="mb-2">
            <p class="text-muted">When to trigger this campaign?</p>
          </div>
          <Row>
            <CheckboxBigSquare
              id="manual-coupon"
              title="Applying a Coupon"
              description=" This promotion will be triggered when a coupon is
                        applied"
              onChange={(event) => {
                setCurrentTriggerType('coupon');
              }}
              checked={currentTriggerType === 'coupon'}
              icon="bx bxs-coupon"
            />
            <CheckboxBigSquare
              id="auto-applied"
              title="Auto Applied"
              description="This promotion is auto applied when the trigger
                        conditions are met"
              onChange={(event) => {
                setCurrentTriggerType('autoapply');
              }}
              checked={currentTriggerType === 'autoapply'}
              icon="ri-compass-discover-line"
            />
            <CheckboxBigSquare
              id="activity"
              title="Activity Based"
              description="This campaign is activated based on an activity or an event. Eg: User Registration, Wishlist (Not on transactions)"
              onChange={(event) => {
                setCurrentTriggerType('activity');
              }}
              checked={currentTriggerType === 'activity'}
              icon="ri-flag-2-line"
            />
            <CheckboxBigSquare
              id="calendar-based"
              title="User Event Based"
              description="This campaign is triggered based on user eg:- birthday, anniversary, etc."
              onChange={(event) => {
                setCurrentTriggerType('event');
              }}
              checked={currentTriggerType === 'event'}
              icon="ri-calendar-event-line"
            />

            <div />
          </Row>
        </Col>
      </Row>
      {/* <If condition={currentTriggerType === 'autoapply'}> */}
      <>
        <If condition={currentTriggerType === 'autoapply'}>
          <Row className="mb-3">
            <Col lg="12">
              <h6 class="mb-0 fw-semibold text-uppercase">
                DISCOVERABLE FIRST
              </h6>

              <div class="form-check form-switch form-switch-lg" dir="ltr">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="discoverableFirst"
                  checked={discoverableFirst}
                  onChange={(event) => {
                    setDiscoverableFirst(event.target.checked);
                  }}
                />
              </div>
              <If condition={discoverableFirst}>
                <>
                  <small class="text-muted">
                    This Promotion won't be applied by default. It will be
                    discovered and applied once it is explicitly provided. Learn
                    More
                  </small>
                </>
              </If>
            </Col>
            <Col lg="12">
              <h6 class="mb-0 fw-semibold text-uppercase">
                Participating Promotion
              </h6>

              <div class="form-check form-switch form-switch-lg" dir="ltr">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="participatingPromotion"
                  checked={participatingPromotion}
                  onChange={(event) => {
                    setParticipatingPromotion(event.target.checked);
                  }}
                />
              </div>
              <If condition={participatingPromotion}>
                <>
                  <small class="text-muted">
                    This promotion is applied when promotion IDs are passed in
                    the API, Learn More
                  </small>
                </>
              </If>
            </Col>
          </Row>
        </If>
        <Row className="mb-3">
          <Col>
            <h6 class="mb-0 fw-semibold text-uppercase">ALWAYS RUN</h6>

            <div class="form-check form-switch form-switch-lg" dir="ltr">
              <input
                type="checkbox"
                class="form-check-input"
                id="alwaysRun"
                checked={alwaysRun}
                onChange={(event) => {
                  setAlwaysRun(event.target.checked);
                }}
              />
            </div>
            <If condition={alwaysRun}>
              <>
                <small class="text-muted">
                  This promotion will run regradless of other promotion's
                  "Discard Subsequently" settings
                </small>
              </>
            </If>
          </Col>
        </Row>

        <If condition={!alwaysRun}>
          <Row className="mb-3">
            <Col>
              <h6 class="mb-0 fw-semibold text-uppercase">
                CAN COMBINE WITH OTHER PROMOTION
              </h6>

              <div class="form-check form-switch form-switch-lg ps-0" dir="ltr">
                {/* <input
                  type="checkbox"
                  class="form-check-input"
                  id="combinableWithPromotion"
                  checked={combinableWithPromotion}
                  onChange={(event) => {
                    setcombinableWithPromotion(event.target.checked);
                  }}
                /> */}
                <CreatableSelect
                  id="combinableWithPromotion"
                  isMulti
                  options={[]}
                  value={combinableWithPromotion?.map((tag) => ({
                    value: tag,
                    label: tag,
                  }))}
                  onChange={(selected) => {
                    const selectedValues = selected
                      ? selected.map((item) => item.value)
                      : [];
                    setcombinableWithPromotion(selectedValues);
                  }}
                  classNamePrefix="select"
                />
              </div>
              <If condition={combinableWithPromotion}>
                <>
                  <small class="text-muted">
                    This promotion will be applied along with any coupon code
                    promotion.
                  </small>
                </>
              </If>
            </Col>
          </Row>
        </If>

        <Row className="mb-3">
          <Col>
            <h6 class="mb-0 fw-semibold text-uppercase">
              Apply Promotion to All Items
            </h6>

            <div class="form-check form-switch form-switch-lg" dir="ltr">
              <input
                type="checkbox"
                class="form-check-input"
                id="promotionAppliedToAllItems"
                checked={promotionAppliedToAllItems}
                onChange={(event) => {
                  setpromotionAppliedToAllItems(event.target.checked);
                }}
              />
            </div>

            <small class="text-muted">
              Check this box to apply the promotion to all items. Unchecking
              will restrict the promotion to only items without an existing
              promotion discount.
            </small>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <h6 class="mb-0 fw-semibold text-uppercase">
                <Label for="discard">Discard Subsequently </Label>
              </h6>
              <Select
                options={DISCARD_SUBSEQUENTLY_OPTIONS}
                value={DISCARD_SUBSEQUENTLY_OPTIONS.find((opt) => {
                  return opt.value === discard;
                })}
                onChange={(selected) => {
                  setDiscard(selected?.value);
                }}
                // classNamePrefix="select"
              />
            </FormGroup>
          </Col>
        </Row>
      </>
      {/* </If> */}

      {/* {!promotionId?.includes('__v') && (
        <Row className="mb-2">
          <Col xs={12}>
            <FormGroup check inline>
              <Label check>
                <Input
                  type="checkbox"
                  checked={!isCouponRequired}
                  onChange={() => setIsCouponRequired(!isCouponRequired)}
                  size="md"
                />
                No Coupon Required
              </Label>
            </FormGroup>
          </Col>
        </Row>
      )} */}

      {currentTriggerType === 'coupon' ? (
        <CreateCouponOptions
          promotionId={promotionId}
          promotionDetail={promotionDetail}
          onCancel={onCancel}
        />
      ) : null}
      <>
        <Row className="mb-4 mt-4">
          <Col>
            <h6 class="mb-0 fw-semibold text-uppercase">Trigger Condition</h6>
            <div className="mb-2">
              <p class="text-muted">
                This promotion will be applied only when the below conditions
                are met
              </p>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <small class="mb-0 fw-semibold text-uppercase">
              Apply using rule or equation
            </small>

            <div class="form-check form-switch form-switch-lg" dir="ltr">
              <input
                type="checkbox"
                class="form-check-input"
                id="triggerConditionType"
                checked={
                  triggeringOptions?.triggerConditionType === 'multipleRules'
                    ? true
                    : false
                }
                onChange={(event) => {
                  setTriggeringOptions((prevState) => {
                    return {
                      ...prevState,
                      triggerConditionType: event.target.checked
                        ? 'multipleRules'
                        : 'singleRule',
                    };
                  });
                }}
              />
            </div>
          </Col>
        </Row>
        <If
          condition={
            triggeringOptions?.triggerConditionType !== 'multipleRules'
          }
        >
          <Then>
            <Row>
              <Col>
                <QueryBuilderApp
                  updateQuery={setCouponQuery}
                  data={couponQuery}
                  fieldGroups={fieldGroups}
                />
              </Col>
            </Row>
          </Then>
        </If>
        <If
          condition={
            triggeringOptions?.triggerConditionType === 'multipleRules'
          }
        >
          <Then>
            <Row>
              <Col>
                {triggeringOptions?.multiRules?.map((rule, index) => (
                  <div key={index} className="mb-4">
                    <h6 className="mb-2">Rule {index + 1}</h6>
                    <QueryBuilderApp
                      updateQuery={(updatedQuery) => {
                        setTriggeringOptions((prevState) => {
                          const updatedRules = [
                            ...(prevState.multiRules || []),
                          ];
                          updatedRules[index] = { query: updatedQuery };
                          return { ...prevState, multiRules: updatedRules };
                        });
                      }}
                      data={rule?.query}
                      fieldGroups={fieldGroups}
                    />
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => {
                        setTriggeringOptions((prevState) => {
                          const updatedRules = [
                            ...(prevState.multiRules || []),
                          ];
                          updatedRules.splice(index, 1);
                          return { ...prevState, multiRules: updatedRules };
                        });
                      }}
                    >
                      Remove Rule
                    </Button>
                  </div>
                ))}
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => {
                    setTriggeringOptions((prevState) => ({
                      ...prevState,
                      multiRules: [...(prevState.multiRules || []), null],
                    }));
                  }}
                >
                  Add Rule
                </Button>
              </Col>
            </Row>

            <Row className="mb-3 mt-4">
              <Col>
                <h6 class="mb-0 fw-semibold text-uppercase">
                  Condition Formula
                </h6>
                <small class="text-muted">
                  Combine the results of all rules using a formula (e.g., Rule1
                  AND Rule2 OR Rule3).
                </small>
                <textarea
                  className="form-control"
                  rows="3"
                  value={triggeringOptions?.conditionFormula || ''}
                  onChange={(event) => {
                    setTriggeringOptions((prevState) => ({
                      ...prevState,
                      conditionFormula: event.target.value,
                    }));
                  }}
                  placeholder="Enter formula here (e.g., Rule1 AND Rule2 OR Rule3)"
                />
              </Col>
            </Row>
          </Then>
        </If>
        <Row>
          <Col xs={12}>
            <ErrorMessagesInLang
              value={promotionDetail?.triggerErrorMessages || []}
              onChange={(values) => {
                setTriggerErrorMessages(values.filter((val) => val.value));
              }}
            />
          </Col>
        </Row>
        {!promotionId?.includes('__v') && (
          <div className="d-flex gap-2 justify-content-end">
            <Button outline color="danger" size="md" onClick={() => {}}>
              Cancel
            </Button>

            <Button
              loading={false}
              color="primary"
              size="md"
              className="bg-gradient px-5"
              onClick={() => {
                saveTriggers();
              }}
            >
              {promotionDetail ? 'Save Draft' : 'Save & Next'}
            </Button>
          </div>
        )}
      </>

      {/* Offcanvas Section */}
      <Offcanvas
        isOpen={isOffcanvasOpen}
        toggle={toggleOffcanvas}
        direction="end"
        style={{ width: '90vw' }}
      >
        <OffcanvasHeader toggle={toggleOffcanvas}>
          {selectedOption === 'coupon' && 'Applying a Coupon'}
          {selectedOption === 'auto' && 'Auto Applied'}
          {selectedOption === 'activity' && 'Activity Based'}
          {selectedOption === 'event' && 'User Event Based'}
        </OffcanvasHeader>
        <OffcanvasBody>
          {selectedOption === 'coupon' && (
            <div>
              <p>Details about activity-based campaigns go here.</p>
            </div>
          )}
          {selectedOption === 'auto' && (
            <div>
              <p>Details about activity-based campaigns go here.</p>
            </div>
          )}
          {selectedOption === 'activity' && (
            <div>
              <p>Details about activity-based campaigns go here.</p>
            </div>
          )}
          {selectedOption === 'event' && (
            <div>
              <p>Details about user event-based campaigns go here.</p>
            </div>
          )}
        </OffcanvasBody>
      </Offcanvas>
      {/* <ToastContainer /> */}
    </>
  );
};

PromotionCoupons.propTypes = {
  promotion: PropTypes.any,
  onCancel: PropTypes.func,
  promotionId: PropTypes.any,
  promotionDetail: PropTypes.any,
  updateHandler: PropTypes.func,
};

export default PromotionCoupons;
